
import { 
    ActionTypes, 
    setUserInfoType,
    submitFormType,
  } from "./types";
  
  
  export const GET_USER_INFO_SAGA = (): ActionTypes => ({
    type: 'GET_USER_INFO_SAGA',
    payload: ''
  });

  export const SET_USER_INFO = (payload: setUserInfoType): ActionTypes => ({
    type: 'SET_USER_INFO',
    payload: payload
  });

  export const GET_QUIZ_INFO_SAGA = (): ActionTypes => ({
    type: 'GET_QUIZ_INFO_SAGA',
    payload: ''
  });

  export const SET_QUIZ_INFO = (payload: string): ActionTypes => ({
    type: 'SET_QUIZ_INFO',
    payload: payload
  });

  export const SUBMIT_FORM_SAGA = (payload: submitFormType): ActionTypes => ({
    type: 'SUBMIT_FORM_SAGA',
    payload: payload
  });


  export const SUBMIT_FORM = (payload: number): ActionTypes => ({
    type: 'SUBMIT_FORM',
    payload: payload
  });
